import React, { useState } from 'react';
import { PlayCircleIcon, SearchIcon, ClockIcon, EyeIcon, BookmarkIcon, ThumbsUpIcon, FilterIcon } from 'lucide-react';
interface Video {
  id: number;
  title: string;
  category: string;
  duration: string;
  views: number;
  likes: number;
  instructor: string;
  thumbnail: string;
  date: string;
  featured?: boolean;
  new?: boolean;
  description: string;
}
const videos: Video[] = [{
  id: 1,
  title: 'Q1 2025 All-Hands Meeting Recording',
  category: 'Company',
  duration: '1:24:00',
  views: 98,
  likes: 47,
  instructor: 'Executive Team',
  thumbnail: 'https://images.unsplash.com/photo-1560472355-536de3962603?w=400&h=225&fit=crop',
  date: 'Mar 5',
  featured: true,
  description: 'Full recording of the Q1 all-hands including product updates and recognition.'
}, {
  id: 2,
  title: 'TRID Compliance Update — March 2025',
  category: 'Compliance',
  duration: '28:14',
  views: 124,
  likes: 61,
  instructor: 'Jennifer Walsh',
  thumbnail: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=225&fit=crop',
  date: 'Mar 1',
  new: true,
  description: 'Critical updates to TRID disclosure requirements effective March 15.'
}, {
  id: 3,
  title: 'Encompass LOS — Advanced Tips & Tricks',
  category: 'Training',
  duration: '42:30',
  views: 76,
  likes: 38,
  instructor: 'IT Department',
  thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=225&fit=crop',
  date: 'Feb 20',
  description: 'Power user workflows, keyboard shortcuts, and automation in Encompass.'
}, {
  id: 4,
  title: 'FHA Loan Guidelines Deep Dive',
  category: 'Products',
  duration: '55:00',
  views: 89,
  likes: 44,
  instructor: 'Mark Chen',
  thumbnail: 'https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?w=400&h=225&fit=crop',
  date: 'Feb 14',
  description: 'Comprehensive review of FHA eligibility, MIP, and underwriting guidelines.'
}, {
  id: 5,
  title: 'Sales Mastery: Converting More Leads',
  category: 'Sales',
  duration: '38:45',
  views: 112,
  likes: 67,
  instructor: 'Carlos Mendez',
  thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=225&fit=crop',
  date: 'Feb 10',
  description: 'Proven scripts, objection handling, and pipeline management strategies.'
}, {
  id: 6,
  title: 'Market Update — Rate Trends Q1 2025',
  category: 'Market',
  duration: '18:22',
  views: 143,
  likes: 72,
  instructor: 'Secondary Markets',
  thumbnail: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=225&fit=crop',
  date: 'Mar 3',
  new: true,
  description: 'Current rate environment, MBS market, and pricing outlook for Q1.'
}, {
  id: 7,
  title: 'New Hire Orientation — Welcome to Swift',
  category: 'HR',
  duration: '1:05:00',
  views: 34,
  likes: 28,
  instructor: 'Lisa Martinez',
  thumbnail: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=400&h=225&fit=crop',
  date: 'Jan 15',
  description: 'Everything new team members need to know about Swift Home Loans.'
}, {
  id: 8,
  title: 'VA Loan Benefits & Eligibility',
  category: 'Products',
  duration: '31:10',
  views: 67,
  likes: 35,
  instructor: 'Mark Chen',
  thumbnail: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=400&h=225&fit=crop',
  date: 'Jan 28',
  description: 'VA loan entitlement, funding fees, and working with veteran borrowers.'
}];
const categories = ['All', 'Company', 'Compliance', 'Training', 'Products', 'Sales', 'Market', 'HR'];
const categoryColors: Record<string, string> = {
  Company: '#1A2B3C',
  Compliance: '#EF4444',
  Training: '#2B8DC4',
  Products: '#1E6FA0',
  Sales: '#1A2B3C',
  Market: '#2B8DC4',
  HR: '#1E6FA0'
};
export function VideoLibrary() {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const [savedIds, setSavedIds] = useState<Set<number>>(new Set([1, 3]));
  const filtered = videos.filter(v => {
    const matchCat = activeCategory === 'All' || v.category === activeCategory;
    const matchSearch = v.title.toLowerCase().includes(search.toLowerCase()) || v.description.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });
  const featured = filtered.find(v => v.featured);
  const rest = filtered.filter(v => !v.featured);
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-548">
      {/* Header */}
      <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 24,
      flexWrap: 'wrap',
      gap: 12
    }} data-id="element-549">
        <div data-id="element-550">
          <h2 style={{
          fontSize: 26,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 3px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em'
        }} data-id="element-551">
            Video Library
          </h2>
          <p style={{
          fontSize: 13,
          color: '#5A6A8A',
          margin: 0
        }} data-id="element-552">
            {videos.length} videos · Training, compliance, and company updates
          </p>
        </div>
        <div style={{
        position: 'relative'
      }} data-id="element-553">
          <SearchIcon size={14} style={{
          position: 'absolute',
          left: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#A0AECB'
        }} data-id="element-554" />
          <input type="text" placeholder="Search videos..." value={search} onChange={e => setSearch(e.target.value)} style={{
          paddingLeft: 30,
          paddingRight: 12,
          paddingTop: 8,
          paddingBottom: 8,
          fontSize: 13,
          borderRadius: 8,
          border: '1.5px solid #E4EAF6',
          background: '#F4F8FC',
          color: '#1A2B3C',
          outline: 'none',
          width: 220
        }} onFocus={e => {
          e.target.style.borderColor = '#2B8DC4';
        }} onBlur={e => {
          e.target.style.borderColor = '#E4EAF6';
        }} data-id="element-555" />
        </div>
      </div>

      {/* Category Filters */}
      <div style={{
      display: 'flex',
      gap: 8,
      flexWrap: 'wrap',
      marginBottom: 20
    }} data-id="element-556">
        {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} style={{
        padding: '6px 14px',
        borderRadius: 6,
        fontSize: 12,
        fontWeight: 800,
        fontStyle: 'italic',
        cursor: 'pointer',
        border: 'none',
        transition: 'all 0.15s',
        background: activeCategory === cat ? '#2B8DC4' : '#FFFFFF',
        color: activeCategory === cat ? '#FFFFFF' : '#5A6A8A',
        boxShadow: activeCategory === cat ? '0 2px 8px rgba(43,141,196,0.3)' : '0 1px 3px rgba(13,27,42,0.08)'
      }} data-id="element-557">
            {cat}
          </button>)}
      </div>

      {/* Featured Video */}
      {featured && activeCategory === 'All' && !search && <div style={{
      background: '#FFFFFF',
      borderRadius: 12,
      overflow: 'hidden',
      marginBottom: 24,
      border: '1px solid #E4EAF6',
      borderTopWidth: 3,
      borderTopColor: '#2B8DC4',
      boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr'
    }} data-id="element-558">
          <div style={{
        position: 'relative',
        overflow: 'hidden'
      }} data-id="element-559">
            <img src={featured.thumbnail} alt={featured.title} style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          minHeight: 220
        }} data-id="element-560" />
            <div style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(135deg, rgba(13,27,42,0.6), rgba(30,111,160,0.4))'
        }} data-id="element-561" />
            <div style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }} data-id="element-562">
              <div style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.95)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 4px 16px rgba(0,0,0,0.3)'
          }} data-id="element-563">
                <PlayCircleIcon size={28} color="#2B8DC4" data-id="element-564" />
              </div>
            </div>
            <span style={{
          position: 'absolute',
          top: 12,
          left: 12,
          fontSize: 10,
          fontWeight: 800,
          padding: '3px 8px',
          borderRadius: 4,
          background: '#2B8DC4',
          color: 'white',
          letterSpacing: '0.06em'
        }} data-id="element-565">
              FEATURED
            </span>
          </div>
          <div style={{
        padding: '28px 28px'
      }} data-id="element-566">
            <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          marginBottom: 10
        }} data-id="element-567">
              <span style={{
            fontSize: 10,
            fontWeight: 800,
            padding: '2px 7px',
            borderRadius: 3,
            background: '#EBF5FB',
            color: '#2B8DC4'
          }} data-id="element-568">
                {featured.category}
              </span>
              <span style={{
            fontSize: 11,
            color: '#A0AECB'
          }} data-id="element-569">
                {featured.date}
              </span>
            </div>
            <h3 style={{
          fontSize: 20,
          fontWeight: 900,
          color: '#1A2B3C',
          fontStyle: 'italic',
          letterSpacing: '-0.03em',
          margin: '0 0 8px',
          lineHeight: 1.2
        }} data-id="element-570">
              {featured.title}
            </h3>
            <p style={{
          fontSize: 13,
          color: '#5A6A8A',
          lineHeight: 1.6,
          margin: '0 0 16px'
        }} data-id="element-571">
              {featured.description}
            </p>
            <div style={{
          display: 'flex',
          gap: 16,
          marginBottom: 20
        }} data-id="element-572">
              <span style={{
            fontSize: 12,
            color: '#A0AECB',
            display: 'flex',
            alignItems: 'center',
            gap: 4
          }} data-id="element-573">
                <ClockIcon size={12} data-id="element-574" /> {featured.duration}
              </span>
              <span style={{
            fontSize: 12,
            color: '#A0AECB',
            display: 'flex',
            alignItems: 'center',
            gap: 4
          }} data-id="element-575">
                <EyeIcon size={12} data-id="element-576" /> {featured.views} views
              </span>
              <span style={{
            fontSize: 12,
            color: '#A0AECB',
            display: 'flex',
            alignItems: 'center',
            gap: 4
          }} data-id="element-577">
                <ThumbsUpIcon size={12} data-id="element-578" /> {featured.likes}
              </span>
            </div>
            <button style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '10px 20px',
          borderRadius: 8,
          background: '#2B8DC4',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
          fontSize: 13,
          fontWeight: 700
        }} data-id="element-579">
              <PlayCircleIcon size={16} data-id="element-580" /> Watch Now
            </button>
          </div>
        </div>}

      {/* Video Grid */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 16
    }} data-id="element-581">
        {rest.map(video => {
        const catColor = categoryColors[video.category] || '#2B8DC4';
        const isSaved = savedIds.has(video.id);
        return <div key={video.id} style={{
          background: '#FFFFFF',
          borderRadius: 12,
          overflow: 'hidden',
          border: '1px solid #E4EAF6',
          borderTopWidth: 3,
          borderTopColor: catColor,
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
          transition: 'all 0.15s',
          cursor: 'pointer'
        }} onMouseEnter={e => {
          ;
          (e.currentTarget as HTMLDivElement).style.boxShadow = '0 4px 16px rgba(43,141,196,0.12)';
          (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-2px)';
        }} onMouseLeave={e => {
          ;
          (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 8px rgba(13,27,42,0.06)';
          (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
        }} data-id="element-582">
              {/* Thumbnail */}
              <div style={{
            position: 'relative',
            overflow: 'hidden',
            height: 160
          }} data-id="element-583">
                <img src={video.thumbnail} alt={video.title} style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }} data-id="element-584" />
                <div style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(13,27,42,0.35)'
            }} data-id="element-585" />
                <div style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} data-id="element-586">
                  <div style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.9)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }} data-id="element-587">
                    <PlayCircleIcon size={22} color="#2B8DC4" data-id="element-588" />
                  </div>
                </div>
                <span style={{
              position: 'absolute',
              bottom: 8,
              right: 8,
              fontSize: 10,
              fontWeight: 700,
              padding: '2px 6px',
              borderRadius: 3,
              background: 'rgba(13,27,42,0.8)',
              color: 'white'
            }} data-id="element-589">
                  {video.duration}
                </span>
                {video.new && <span style={{
              position: 'absolute',
              top: 8,
              left: 8,
              fontSize: 9,
              fontWeight: 800,
              padding: '2px 6px',
              borderRadius: 3,
              background: '#2B8DC4',
              color: 'white',
              letterSpacing: '0.06em'
            }} data-id="element-590">
                    NEW
                  </span>}
                <button onClick={e => {
              e.stopPropagation();
              setSavedIds(prev => {
                const n = new Set(prev);
                isSaved ? n.delete(video.id) : n.add(video.id);
                return n;
              });
            }} style={{
              position: 'absolute',
              top: 8,
              right: 8,
              background: isSaved ? '#2B8DC4' : 'rgba(255,255,255,0.9)',
              border: 'none',
              borderRadius: 5,
              padding: '4px 6px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-591">
                  <BookmarkIcon size={13} color={isSaved ? 'white' : '#5A6A8A'} fill={isSaved ? 'white' : 'none'} data-id="element-592" />
                </button>
              </div>

              {/* Info */}
              <div style={{
            padding: '14px 16px'
          }} data-id="element-593">
                <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              marginBottom: 6
            }} data-id="element-594">
                  <span style={{
                fontSize: 10,
                fontWeight: 800,
                padding: '2px 6px',
                borderRadius: 3,
                background: `${catColor}15`,
                color: catColor
              }} data-id="element-595">
                    {video.category}
                  </span>
                  <span style={{
                fontSize: 10,
                color: '#A0AECB'
              }} data-id="element-596">
                    {video.date}
                  </span>
                </div>
                <div style={{
              fontSize: 13,
              fontWeight: 800,
              color: '#1A2B3C',
              fontStyle: 'italic',
              letterSpacing: '-0.01em',
              lineHeight: 1.3,
              marginBottom: 4
            }} data-id="element-597">
                  {video.title}
                </div>
                <div style={{
              fontSize: 11,
              color: '#5A6A8A',
              marginBottom: 10,
              lineHeight: 1.4
            }} data-id="element-598">
                  {video.description}
                </div>
                <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12
            }} data-id="element-599">
                  <span style={{
                fontSize: 11,
                color: '#A0AECB',
                display: 'flex',
                alignItems: 'center',
                gap: 3
              }} data-id="element-600">
                    <EyeIcon size={11} data-id="element-601" /> {video.views}
                  </span>
                  <span style={{
                fontSize: 11,
                color: '#A0AECB',
                display: 'flex',
                alignItems: 'center',
                gap: 3
              }} data-id="element-602">
                    <ThumbsUpIcon size={11} data-id="element-603" /> {video.likes}
                  </span>
                  <span style={{
                fontSize: 11,
                color: '#A0AECB',
                marginLeft: 'auto'
              }} data-id="element-604">
                    by {video.instructor}
                  </span>
                </div>
              </div>
            </div>;
      })}
      </div>

      {filtered.length === 0 && <div style={{
      textAlign: 'center',
      padding: '48px 0'
    }} data-id="element-605">
          <PlayCircleIcon size={44} color="#C8D8E8" style={{
        marginBottom: 12
      }} data-id="element-606" />
          <p style={{
        fontWeight: 700,
        color: '#5A6A8A',
        margin: '0 0 4px'
      }} data-id="element-607">
            No videos found
          </p>
          <p style={{
        fontSize: 13,
        color: '#A0AECB',
        margin: 0
      }} data-id="element-608">
            Try adjusting your search or filter
          </p>
        </div>}
    </div>;
}